import { Icon } from '@iconify/react'
import type { PublicCampaignTemplateOption } from '@/lib/campaigns'
import {
  getPublicCampaignTemplateDefinition,
  resolvePublicCampaignTemplateKey,
} from '@/features/publicCampaignTemplates/registry'
import template1Preview from './template-preview-1.svg'
import template2Preview from './template-preview-2.svg'
import template3Preview from './template-preview-3.svg'
import styles from './PublicCampaignTemplatePicker.module.css'

type PublicCampaignTemplatePickerProps = {
  options: PublicCampaignTemplateOption[]
  selectedKey: string
  onChange: (templateKey: string) => void
}

function getPreview(templateKey: string): { src: string; alt: string } {
  const resolved = resolvePublicCampaignTemplateKey(templateKey)
  if (resolved === 'template-3') {
    return {
      src: template3Preview,
      alt: 'Exemplo do Template 3: foto de fundo, chamada e prêmio em destaque, com informações abaixo',
    }
  }
  if (resolved === 'template-2') {
    return {
      src: template2Preview,
      alt: 'Exemplo do Template 2: página escura com galeria, detalhes e compra em cartões',
    }
  }
  return {
    src: template1Preview,
    alt: 'Exemplo do Template 1: página clara com galeria à esquerda e compra à direita',
  }
}

export function PublicCampaignTemplatePicker({
  options,
  selectedKey,
  onChange,
}: PublicCampaignTemplatePickerProps) {
  return (
    <div className={styles.picker}>
      <div className={styles.grid}>
        {options.map((option) => {
          const definition = getPublicCampaignTemplateDefinition(option.key)
          const isSelected = option.key === selectedKey
          const preview = getPreview(option.key)

          return (
            <button
              key={option.key}
              type="button"
              className={`${styles.card} ${isSelected ? styles.cardSelected : ''}`}
              onClick={() => onChange(option.key)}
              aria-label={`${option.name}: ${option.description}`}
              aria-pressed={isSelected}
              aria-current={isSelected ? 'true' : undefined}
            >
              {isSelected ? (
                <span className={styles.badge}>
                  <Icon icon="mdi:check-circle" aria-hidden />
                  Selecionado
                </span>
              ) : null}
              <div className={styles.preview}>
                <img
                  src={preview.src}
                  alt={preview.alt}
                  loading="lazy"
                  draggable={false}
                />
              </div>

              <div className={styles.content}>
                <div className={styles.titleBlock}>
                  <h4 className={styles.title}>{option.name}</h4>
                  <p className={styles.description}>{option.description}</p>
                </div>
                {definition.description !== option.description && (
                  <p className={styles.description}>{definition.description}</p>
                )}
              </div>
            </button>
          )
        })}
      </div>
    </div>
  )
}
